import { getTvObject, tv } from '@costar-ui/cosmos';

var comboBoxTV = getTvObject({
  slots: {
    base: 'group relative w-full text-on-base',
    label: 'w-full',
    button: ['w-fit', 'items-center', 'px-1', 'py-0', 'hover:bg-transparent', 'pressed:bg-transparent'],
    subText: 'w-full',
    listBox: 'max-h-[400px] w-full overflow-auto border-0 outline-2 outline-focus'
  },
  variants: {
    variant: {
      standard: {
        button: ['hover:outline-1', 'pressed:outline-1']
      },
      ghost: {
        button: 'px-0 hover:text-action-primary-hover'
      }
    },
    size: {
      std: {
        base: 'text-p-16',
        listBox: 'text-p-16'
      },
      sm: {
        base: 'text-p-14',
        listBox: 'text-p-14'
      },
      xxs: {
        base: 'text-p-12',
        listBox: 'text-p-12'
      }
    },
    layout: {
      grid: {
        base: 'flex flex-col gap-1'
      },
      relative: {
        label: 'absolute translate-y-[calc(-100%_-_0.25rem)] leading-5',
        subText: 'absolute bottom-0 translate-y-[calc(100%_+_0.25rem)]'
      }
    },
    screenReaderOnly: {
      "true": {
        label: 'sr-only',
        subText: 'sr-only'
      }
    }
  }
});
var base = tv(comboBoxTV);
var comboBoxStyles = {
  base: base
};

export { comboBoxStyles, comboBoxTV };
//# sourceMappingURL=combo-box.styles.esm.js.map
